"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _FinishLineSquared = _interopRequireDefault(require("./FinishLineSquared"));
require("./styles.css");
var _greenFlag = require("../../assets/race-track/green-flag.svg");
var _clearButton = require("../../assets/race-track/clear-button.svg");
var _stopButton = require("../../assets/race-track/stop-button.svg");
var _AddedMovement = _interopRequireDefault(require("./AddedMovement"));
var _RCSequencerManager = _interopRequireDefault(require("../../utils/RCSequencer/RCSequencerManager"));
var _updaterContext = _interopRequireDefault(require("../../store/updater-context"));
var _react = require("react");
var _sequencerToggleContext = _interopRequireDefault(require("../../store/sequencer-toggle-context"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MOVEMENTS_PER_TRACK = 5;
const getRaceTrackMovesJSX = (iStart, iEnd) => {
  const raceTrackMovesJSX = [];
  for (let i = iStart; i < iEnd; i++) {
    if (i >= _RCSequencerManager.default.sequence.length) {
      // we do not have a movement, render circle
      raceTrackMovesJSX.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "movement-spot",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "movement-spot-empty-space"
        })
      }, "empty" + i));
    } else {
      // we have a movement
      const movement = _RCSequencerManager.default.sequence[i];
      raceTrackMovesJSX.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "movement-spot",
        onClick: () => _RCSequencerManager.default.removeFromSequenceByIdx(i),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddedMovement.default, {
          removable: !_RCSequencerManager.default.currentlyRunningMovement,
          isExecuting: movement === _RCSequencerManager.default.currentlyRunningMovement,
          movement: movement.iconName,
          speed: movement.moveSpeedLabel
        })
      }, "movement" + i));
    }
  }
  return raceTrackMovesJSX;
};
const RaceTrackSection = () => {
  const _ = (0, _react.useContext)(_updaterContext.default);
  const sequencerToggleCtx = (0, _react.useContext)(_sequencerToggleContext.default);
  const firstRaceTrackMovesJSX = getRaceTrackMovesJSX(0, MOVEMENTS_PER_TRACK);
  const secondRaceTrackMovesJSX = getRaceTrackMovesJSX(MOVEMENTS_PER_TRACK, MOVEMENTS_PER_TRACK * 2);
  const thirdRaceTrackMovesJSX = getRaceTrackMovesJSX(MOVEMENTS_PER_TRACK * 2, MOVEMENTS_PER_TRACK * 3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
    className: "race-track-section",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "race-track-css",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "race-track-green-flag",
        onClick: () => {
          // if it's running, pause/stop, otherwise start executing
          if (_RCSequencerManager.default.currentlyRunningMovement) {
            _RCSequencerManager.default.pauseExecution();
            _RCSequencerManager.default.resetAndPrepareSequence();
            !sequencerToggleCtx.sequencerToggle && _RCSequencerManager.default.clearSequence();
          } else {
            _RCSequencerManager.default.resetAndPrepareSequence();
            _RCSequencerManager.default.executeNext();
          }
        },
        children: _RCSequencerManager.default.currentlyRunningMovement ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_stopButton.ReactComponent, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_greenFlag.ReactComponent, {
          style: {
            opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "race-track-clear-button",
        onClick: () => _RCSequencerManager.default.clearSequence(),
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_clearButton.ReactComponent, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "first-track",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FinishLineSquared.default, {
          customStyles: {
            justifySelf: "start"
          }
        }), sequencerToggleCtx.sequencerToggle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "movements-box",
          children: firstRaceTrackMovesJSX
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "big-right-turn",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "small-right-turn",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "second-track",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        },
        children: sequencerToggleCtx.sequencerToggle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "movements-box",
          children: secondRaceTrackMovesJSX
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "third-track",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FinishLineSquared.default, {
          customStyles: {
            gridColumn: "2/2"
          }
        }), sequencerToggleCtx.sequencerToggle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "movements-box",
          children: thirdRaceTrackMovesJSX
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "big-left-turn",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "small-left-turn",
        style: {
          opacity: sequencerToggleCtx.sequencerToggle ? 1 : 0.5
        }
      }), sequencerToggleCtx.sequencerToggle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "left-arrow-stick"
      }), sequencerToggleCtx.sequencerToggle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "right-arrow-stick"
      })]
    })
  });
};
var _default = exports.default = RaceTrackSection;